"use strict";

import angular from "angular";

import FileSaver from "file-saver";
import { HTMLToImage } from "../../../presentation/services/HTMLToImage/HTMLToImage";
import toastCustomTemplate from "../../components/nu-toast-custom/toast-custom.component.html";

class OneMillionShareDialogCtrl {
    isLevelUp = false;
    statusImpact = {
        bronze: "bronze",
        prata: "silver",
        ouro: "gold",
        embaixador: "envoy"
    };

    constructor($mdDialog, locals, DSNDialogService, $state, $scope, toast) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
        this.data = locals.data;
        this.DSNDialogService = DSNDialogService;
        this.$state = $state;
        this.$scope = $scope;
        this.toast = toast;
        this.accountingData = locals.accountingData;

        this.statusUpperCase = "";
        this.level = "bronze";
    }

    $onInit() {
        this.isLevelUp = this.locals?.isLevelUp;

        if (this.locals?.status)
            this.statusUpperCase = this.locals.status.toLocaleUpperCase();

        this.level = this.locals?.status;
    }

    async onCopyImage() {
        const htmlToImage = new HTMLToImage();
        const element = document.getElementById("ToImageWrapper");
        try {
            const blob = await htmlToImage.toBlob({
                element,
                options: {
                    skipFonts: true,
                    width: 445,
                    height: 445,
                    type: "image/jpeg",
                    quality: 1,
                    cacheBust: true
                }
            });
            await navigator.clipboard.write([
                new ClipboardItem({
                    [blob.type]: blob
                })
            ]);
            this.$mdDialog.hide();
            this.toastMessage("Imagem copiada com sucesso");
        } catch (error) {
            console.error("oops, something went wrong!", error);
            this.$mdDialog.cancel();
        }
    }

    async onDownloadImage() {
        const htmlToImage = new HTMLToImage();
        const element = document.getElementById("ToImageWrapper");
        try {
            const blob = await htmlToImage.toBlob({
                element,
                options: {
                    skipFonts: true,
                    width: 445,
                    height: 445,
                    type: "image/jpeg",
                    quality: 1,
                    cacheBust: true
                }
            });
            if (window.saveAs)
                window.saveAs(blob, "missao-1-milhao-nucont.jpeg");
            else FileSaver.saveAs(blob, "missao-1-milhao-nucont.jpeg");
            this.$mdDialog.hide();
            this.toastMessage("Imagem baixada com sucesso");
        } catch (error) {
            console.error("oops, something went wrong!", error);
            this.$mdDialog.cancel();
        }
    }

    toastMessage(toastMessage) {
        this.toast.show("", "bottom right", {
            hideDelay: 2000,
            controllerAs: "ctrl",
            locals: {
                toastMessage,
                action: [
                    {
                        style:
                            "md-icon-button dsn-icon-button dsn-icon-button-medium",
                        icon: "dsn-icon-button fas fa-times",
                        click: () => {
                            this.toast.hide();
                        }
                    }
                ]
            },
            template: toastCustomTemplate
        });
    }
}

angular
    .module("nucont.shared")
    .controller("OneMillionShareDialogCtrl", [
        "$mdDialog",
        "locals",
        "DSNDialogService",
        "$state",
        "$scope",
        "toast",
        OneMillionShareDialogCtrl
    ]);
